import React from "react";
import './SubsidiaryCompany.css'
import useMeta from '../../../hooks/useMeta'

import Navbar from "../../../CommonComponent/Navbar/Navbar";
import NotificationBar from "../../../CommonComponent/Notification/NotificationBar";
import Footer from "../../../CommonComponent/Footer/footer";
import { Link } from "react-router-dom";


const SubsidiaryCompany = () => {

    useMeta({
        title: 'Subsidiary Company | Marvel Blinds',
        description: null,
        canonical: `${process.env.REACT_APP_WEBSITE_URL}/subsidiary-company`,
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'Subsidiary Company',
            description: null,
            url: `${process.env.REACT_APP_WEBSITE_URL}/subsidiary-company`,
            site_name: 'Marvel Blinds',
        },
    });

    return (
        <>
            <Navbar />
            <NotificationBar />
            <div className="SC_pg_container">
                <h2 className="SC_pg_title">Subsidiary Company</h2>
                <Link className="SC_content" to="/subsidiary-company/uk-ltd">Callistus Window Fashion USA Inc</Link>
                <Link className="SC_content" to="/subsidiary-company/middle-east">Callistus Blinds Middle East FZE</Link>
                <Link className="SC_content" to="/subsidiary-company/uk-ltd">Callistus UK Limited</Link>
            </div>
            <Footer />
        </>
    );
}

export default SubsidiaryCompany;